import { type CrehanaTFunction, useTranslation } from '@crehana/i18n';

import type { UserDashboardLocaleKeys } from '../types';

export const useCrehanaTranslation =
  (): CrehanaTFunction<UserDashboardLocaleKeys> => {
    const { t } = useTranslation<UserDashboardLocaleKeys>();

    return t;
  };
